import { privateClient } from "@/api/privateClient";
import { SUPER_ADMIN_ENDPOINTS } from "../../../endpoint";
import type { CmsPage, PageFormData, PaginatedPages, PageStatus } from "../types";

const E = SUPER_ADMIN_ENDPOINTS.CMS.PAGES;

export const listAdminPages = async (page = 1, limit = 20): Promise<PaginatedPages> => {
  const { data } = await privateClient.get(E.LIST_ADMIN, { params: { page, limit } });
  return data;
};

export const getAdminPage = async (id: number): Promise<CmsPage> => {
  const { data } = await privateClient.get(E.DETAIL_ADMIN(id));
  return data.page ?? data;
};

export const createPage = async (payload: PageFormData): Promise<CmsPage> => {
  const { data } = await privateClient.post(E.CREATE, payload);
  return data.page ?? data;
};

export const updatePage = async (id: number, payload: PageFormData): Promise<CmsPage> => {
  const { data } = await privateClient.put(E.UPDATE(id), payload);
  return data.page ?? data;
};

export const setPageStatus = async (id: number, status: PageStatus): Promise<CmsPage> => {
  const { data } = await privateClient.put(E.SET_STATUS(id), { status });
  return data.page ?? data;
};

export const deletePage = async (id: number): Promise<void> => {
  await privateClient.delete(E.DELETE(id));
};
